import { useState, useEffect } from 'react';
import Icon from '@/components/base/Icon';

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-5 right-5 z-50">
      <a
        href="https://wa.me/5544997181872?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento."
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1fae55] transition-all hover:scale-110"
        aria-label="WhatsApp"
      >
        <div className="w-7 h-7 flex items-center justify-center">
          <Icon name="whatsapp" className="text-white" size={28} />
        </div>
      </a>
    </div>
  );
}
